module.exports = __webpack_public_path__ + "img/mastercard.2a1417f2.png";